import React from 'react';
import './Cards.css';

function CardTournamentInfo(props) {
  return (
    <React.Fragment>
      <li className='cards__item'>
        <div className='cards__item__base'>
          <div className='cards__item__base__info'>
            <h4 className='cards__item__base__label'>{props.label1}</h4>
            <h5 className='cards__item__base__text'>{props.text1}</h5>
            <h5 className='cards__item__base__text'>{props.text2}</h5>
            <h5 className='cards__item__base__text__margin'>{props.text3}</h5>
            <h4 className='cards__item__base__label'>{props.label2}</h4>
            <h5 className='cards__item__base__text'>{props.text4}</h5>
            <h5 className='cards__item__base__text__margin'>{props.text5}</h5>
            <h4 className='cards__item__base__label'>{props.label3}</h4>
            <h5 className='cards__item__base__text'>{props.text6}</h5>
            <h5 className='cards__item__base__text__margin'>{props.text7}</h5>
          </div>
        </div>
      </li>   
    </React.Fragment>
  );
}

export default CardTournamentInfo;